import {fromJS} from 'immutable'
import {post} from '../../util/http'
import SubjectToCSSName, {IdToEnglishName} from '../../core/less/SubjectToCSSName'

/**
 * Actions
 */
const FETCH_ENTRY_TOPIC_TITLES = 'expii/entryTopicTitles/FETCH_ENTRY_TOPIC_TITLES'

/**
 * Action Creators
 */
function fetchEntryTopicTitles(titles) {
  return { type: FETCH_ENTRY_TOPIC_TITLES, titles }
}

/**
 * Reducer
 */
const defaultEntryTopicTitlesState = fromJS({
  titles: IdToEnglishName
})

export default function reducer(state = defaultEntryTopicTitlesState, action) {
  switch (action.type) {
  case FETCH_ENTRY_TOPIC_TITLES:
    return state.mergeDeepWith(
      (oldVal,newVal) => {
        if (oldVal.length && !newVal.length) {
          return oldVal
        }
        return newVal
      },
      fromJS({
        titles: action.titles
      }))
  default:
    return state
  }
}

/**
* Side Effects
*/

export function getEntryTopicTitles() {
  return (dispatch, getState) => {
    return post(`/api/v2/topic_titles`,{'ids':Object.keys(SubjectToCSSName)})
      .then((json)=>{
        const {output} = json
        dispatch(fetchEntryTopicTitles(output))
      })
  }
}

/**
* Selector
*/

export const selectEntryTopicTitles = (state) => (state.getIn(['entryTopicTitles','titles']))



// WEBPACK FOOTER //
// ./src/redux/modules/entryTopicTitles.js